(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prod-d"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__nagGridLoaded) return;
    window.__nagGridLoaded = true;

    var state = null;

    function routesRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function prefersReduced() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function toast(sectionEl, message) {
      var el = sectionEl && sectionEl.querySelector('[data-nag-toast]');
      if (!el) return;
      el.textContent = message;
      el.hidden = false;
      clearTimeout(el._nagTimer);
      el._nagTimer = setTimeout(function () { el.hidden = true; }, 3500);
    }

    /* ---------- Cart ---------- */
    function cartSections() {
      var list = ['cart-icon-bubble'];
      if (document.querySelector('cart-drawer')) list.push('cart-drawer');
      if (document.querySelector('cart-notification')) {
        list.push('cart-notification-product');
        list.push('cart-notification-button');
      }
      return list.join(',');
    }

    function addToCart(variantId, quantity) {
      var body = {
        id: variantId,
        quantity: quantity,
        sections: cartSections(),
        sections_url: window.location.pathname
      };
      return fetch(routesRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok) {
            throw new Error(json.description || json.message || 'Could not add this item to the cart.');
          }
          return json;
        });
      });
    }

    function updateBubble(json) {
      function apply(html) {
        var el = document.getElementById('cart-icon-bubble');
        if (!el || !html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.querySelector('.shopify-section');
        el.innerHTML = src ? src.innerHTML : html;
      }
      if (json && json.sections && json.sections['cart-icon-bubble']) {
        apply(json.sections['cart-icon-bubble']);
        return;
      }
      fetch(routesRoot() + '?sections=cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (d) { apply(d['cart-icon-bubble']); })
        .catch(function () {});
    }

    function refreshCart(json) {
      var drawer = document.querySelector('cart-drawer');
      var notification = document.querySelector('cart-notification');
      try {
        if (drawer && typeof drawer.renderContents === 'function' && json && json.sections) {
          drawer.renderContents(json);
          return;
        }
        if (notification && typeof notification.renderContents === 'function' && json && json.sections) {
          notification.renderContents(json);
          return;
        }
      } catch (e) {
        if (window.console) console.warn('New arrivals grid: theme cart refresh failed, using fallback.', e);
      }
      updateBubble(json);
    }

    /* ---------- Plus button ---------- */
    function onPlus(btn, event) {
      event.preventDefault();
      if (btn.disabled || btn.classList.contains('is-loading')) return;

      var section = btn.closest('.nag');
      var card = btn.closest('.nag-card');
      var behavior = btn.getAttribute('data-behavior');
      var multi = btn.getAttribute('data-multi') === 'true';

      if (behavior === 'popup' && multi) {
        openModal(section, card, btn);
        return;
      }

      var id = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!id) {
        window.location.href = btn.getAttribute('data-url');
        return;
      }

      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');

      addToCart(id, 1).then(function (json) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-success');
        refreshCart(json);
        setTimeout(function () { btn.classList.remove('is-success'); }, 1600);
      }).catch(function (error) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        toast(section, error.message);
      });
    }

    /* ---------- Quick add popup ---------- */
    function findVariant(selected) {
      var variants = state.data.variants;
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var k = 0; k < selected.length; k++) {
          if (variants[i].options[k] !== selected[k]) { ok = false; break; }
        }
        if (ok) return variants[i];
      }
      return null;
    }

    function renderOptions() {
      var wrap = state.modal.querySelector('[data-nag-modal-options]');
      wrap.textContent = '';
      if (state.data.variants.length <= 1) return;

      state.data.options.forEach(function (name, i) {
        var group = document.createElement('div');
        group.className = 'nag-opt';

        var label = document.createElement('span');
        label.className = 'nag-opt__label';
        label.textContent = name;
        group.appendChild(label);

        var row = document.createElement('div');
        row.className = 'nag-opt__row';
        row.setAttribute('role', 'radiogroup');
        row.setAttribute('aria-label', name);

        var values = [];
        state.data.variants.forEach(function (v) {
          if (values.indexOf(v.options[i]) === -1) values.push(v.options[i]);
        });

        values.forEach(function (val) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'nag-opt__btn';
          b.textContent = val;
          b.setAttribute('role', 'radio');
          b.setAttribute('data-index', String(i));
          b.setAttribute('data-value', val);
          row.appendChild(b);
        });

        group.appendChild(row);
        wrap.appendChild(group);
      });
    }

    function updateModal() {
      var modal = state.modal;
      var v = state.variant;

      var priceEl = modal.querySelector('[data-nag-modal-price]');
      priceEl.textContent = '';
      var now = document.createElement('span');
      now.textContent = v.price;
      priceEl.appendChild(now);
      if (v.onSale) {
        var was = document.createElement('s');
        was.textContent = v.compare;
        priceEl.appendChild(was);
      }

      var buttons = modal.querySelectorAll('.nag-opt__btn');
      Array.prototype.forEach.call(buttons, function (b) {
        var i = parseInt(b.getAttribute('data-index'), 10);
        var val = b.getAttribute('data-value');
        b.setAttribute('aria-checked', state.selected[i] === val ? 'true' : 'false');

        var available = state.data.variants.some(function (variant) {
          if (variant.options[i] !== val || !variant.available) return false;
          for (var j = 0; j < state.selected.length; j++) {
            if (j !== i && variant.options[j] !== state.selected[j]) return false;
          }
          return true;
        });
        b.classList.toggle('is-unavailable', !available);
      });

      var add = modal.querySelector('[data-nag-modal-add]');
      add.disabled = !v.available;
      add.textContent = v.available ? 'Add to cart' : 'Sold out';
    }

    function setQty(n) {
      n = parseInt(n, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > 99) n = 99;
      state.qty = n;
      state.modal.querySelector('[data-nag-qty-input]').value = n;
    }

    function openModal(section, card, trigger) {
      var modal = section.querySelector('[data-nag-modal]');
      var script = card.querySelector('[data-nag-json]');
      if (!modal || !script) return;

      var data;
      try {
        data = JSON.parse(script.textContent);
      } catch (e) {
        window.location.href = trigger.getAttribute('data-url');
        return;
      }

      var first = null;
      for (var i = 0; i < data.variants.length; i++) {
        if (data.variants[i].available) { first = data.variants[i]; break; }
      }
      if (!first) first = data.variants[0];

      state = { modal: modal, data: data, trigger: trigger, section: section, qty: 1, variant: first, selected: first.options.slice() };

      modal.querySelector('[data-nag-modal-title]').textContent = data.title;
      modal.querySelector('[data-nag-modal-link]').setAttribute('href', data.url);
      var media = modal.querySelector('[data-nag-modal-media]');
      var img = modal.querySelector('[data-nag-modal-img]');
      if (data.image) {
        img.src = data.image;
        img.alt = data.title;
        media.hidden = false;
      } else {
        media.hidden = true;
      }
      modal.querySelector('[data-nag-modal-error]').hidden = true;

      renderOptions();
      setQty(1);
      updateModal();

      modal.hidden = false;
      document.documentElement.classList.add('nag-lock');
      var dialog = modal.querySelector('.nag-modal__dialog');
      if (dialog) dialog.focus();
    }

    function closeModal(skipFocus) {
      if (!state) return;
      var trigger = state.trigger;
      state.modal.hidden = true;
      document.documentElement.classList.remove('nag-lock');
      state = null;
      if (!skipFocus && trigger && trigger.focus) trigger.focus();
    }

    function submitModal() {
      if (!state || !state.variant || !state.variant.available) return;
      var btn = state.modal.querySelector('[data-nag-modal-add]');
      var err = state.modal.querySelector('[data-nag-modal-error]');
      err.hidden = true;
      btn.disabled = true;
      btn.textContent = 'Adding...';

      addToCart(state.variant.id, state.qty).then(function (json) {
        closeModal(true);
        refreshCart(json);
      }).catch(function (error) {
        if (!state) return;
        err.textContent = error.message;
        err.hidden = false;
        updateModal();
      });
    }

    /* ---------- Slider dots ---------- */
    function syncDots(slider) {
      var width = slider.clientWidth || 1;
      var index = Math.round(Math.abs(slider.scrollLeft) / width);
      var media = slider.closest('.nag-media');
      if (!media) return;
      var dots = media.querySelectorAll('.nag-dot');
      Array.prototype.forEach.call(dots, function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    var ticking = false;
    document.addEventListener('scroll', function (event) {
      var target = event.target;
      if (!target || !target.classList || !target.classList.contains('nag-slider')) return;
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        syncDots(target);
      });
    }, true);

    /* ---------- Delegated events ---------- */
    document.addEventListener('click', function (event) {
      var t = event.target;
      if (!t || !t.closest) return;

      var dot = t.closest('.nag-dot');
      if (dot) {
        event.preventDefault();
        event.stopPropagation();
        var media = dot.closest('.nag-media');
        var slider = media && media.querySelector('.nag-slider');
        if (slider) {
          slider.scrollTo({
            left: parseInt(dot.getAttribute('data-index'), 10) * slider.clientWidth,
            behavior: prefersReduced() ? 'auto' : 'smooth'
          });
        }
        return;
      }

      var plus = t.closest('[data-nag-plus]');
      if (plus) {
        onPlus(plus, event);
        return;
      }

      if (!state) return;

      if (t.closest('[data-nag-close]')) {
        closeModal();
        return;
      }

      var opt = t.closest('.nag-opt__btn');
      if (opt && state.modal.contains(opt)) {
        var i = parseInt(opt.getAttribute('data-index'), 10);
        var val = opt.getAttribute('data-value');
        var next = state.selected.slice();
        next[i] = val;
        var match = findVariant(next);
        if (!match) {
          for (var k = 0; k < state.data.variants.length; k++) {
            if (state.data.variants[k].options[i] === val) { match = state.data.variants[k]; break; }
          }
        }
        if (match) {
          state.variant = match;
          state.selected = match.options.slice();
          updateModal();
        }
        return;
      }

      if (t.closest('[data-nag-qty-minus]')) { setQty(state.qty - 1); return; }
      if (t.closest('[data-nag-qty-plus]')) { setQty(state.qty + 1); return; }
      if (t.closest('[data-nag-modal-add]')) { submitModal(); return; }
    });

    document.addEventListener('change', function (event) {
      if (state && event.target && event.target.matches && event.target.matches('[data-nag-qty-input]')) {
        setQty(event.target.value);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!state) return;
      if (event.key === 'Escape') {
        closeModal();
        return;
      }
      if (event.key === 'Tab') {
        var all = state.modal.querySelectorAll('a[href], button:not([disabled]), input, select, textarea');
        var items = Array.prototype.filter.call(all, function (el) { return el.offsetParent !== null; });
        if (!items.length) return;
        var firstEl = items[0];
        var lastEl = items[items.length - 1];
        var active = document.activeElement;
        var dialog = state.modal.querySelector('.nag-modal__dialog');
        if (event.shiftKey && (active === firstEl || active === dialog)) {
          event.preventDefault();
          lastEl.focus();
        } else if (!event.shiftKey && active === lastEl) {
          event.preventDefault();
          firstEl.focus();
        }
      }
    });

    document.addEventListener('shopify:section:unload', function () {
      if (state) closeModal(true);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
